// Mapping code d'erreur backend → message FR (WKF-013 §6.2).

import type { TFunction } from 'i18next'

const CODE_FALLBACKS: Record<string, string> = {
    NOTIFICATION_NOT_FOUND: "Cette notification n'existe plus.",
    NOTIFICATION_FORBIDDEN: 'Cette notification ne vous est pas destinée.',
    TASK_NOT_FOUND: "Cette tâche n'existe plus.",
    TASK_TITLE_REQUIRED: 'Donnez un titre à votre tâche.',
    TASK_ASSIGNEE_UNKNOWN: 'Cet utilisateur ne fait pas partie de votre organisme.',
    // Tâche liée à un appel d'offres confiée à qui ne voit pas l'entité de l'AO (PO n° 66).
    TASK_ASSIGNEE_OUT_OF_TENDER:
        "Ce collègue n'a pas accès aux appels d'offres de l'entité de cette consultation.",
    // Alerte de révision d'un contrat cadre transférée à qui n'en voit pas les montants (défaut 69).
    TASK_ASSIGNEE_WITHOUT_PRICING:
        "Ce collègue ne peut pas recevoir cette alerte de révision : elle montre les montants du contrat, et il n'a pas la permission « Clients : Prix négociés (contrats cadre) » sur l'entité de ce client.",
    TASK_ASSIGN_FORBIDDEN:
        'Vous ne pouvez pas assigner une tâche à un collègue (permission requise).',
    TASK_TRANSFER_TO_SELF: 'Vous ne pouvez pas transférer une tâche à vous-même.',
    TASK_SNOOZE_DATE_INVALID: 'La date de report doit être dans le futur.',
    TASK_BULK_EMPTY: 'Sélectionnez au moins une tâche.',
    TASK_ADMIN_FORBIDDEN: "La gestion des tâches de l'équipe requiert un rôle d'administrateur.",
    VALIDATION_ERROR: 'Requête invalide. Rechargez la page puis réessayez.',
}

export function notificationErrorMessage(err: unknown, t: TFunction): string {
    const code =
        err && typeof err === 'object' && 'code' in err
            ? String((err as { code?: string }).code)
            : undefined
    const fallback =
        (code && CODE_FALLBACKS[code]) ||
        (err instanceof Error ? err.message : '') ||
        'Une erreur est survenue.'
    if (code && CODE_FALLBACKS[code]) {
        return t(`notifications.errors.${code}`, fallback)
    }
    return fallback
}
